



















export default {
  name: "InputPreview2",
  props: {
    content: {
      type: Object,
      required: true
    },
    title: {
      type: String
    },
    value: {
      type: Object,
      required: true
    }
  }
};
